import * as palette from "@govlaunch/palette";
import React from "react";
import { FormattedMessage } from "react-intl";
import useIntlDate from "~/lib/hooks/useIntlDate";
import Strongify from "~/lib/utils/strongify";

interface IDowngradeSuccessfulProps {
  willCancelAt: Date;
}

export default function DowngradeSuccessful({ willCancelAt }: IDowngradeSuccessfulProps) {
  const intlDate = useIntlDate();

  return (
    <div
      css={{
        display: "grid",
        gridRowGap: 20,
        padding: 20,
        backgroundColor: palette.white,
        border: `solid 1px ${palette.lightestGray}`,
        borderRadius: 4,
      }}
    >
      <div
        css={{
          display: "grid",
          gridRowGap: 12,
        }}
      >
        <h2
          css={{
            margin: 0,
          }}
        >
          <FormattedMessage defaultMessage="Downgrade Successful" id="KP+2qb" />
        </h2>

        <p
          css={{
            margin: 0,
            color: palette.mediumGray,
            fontSize: 14,
            lineHeight: 1.33,
          }}
        >
          <FormattedMessage
            defaultMessage="Change will be effective at the end of your billing period on <strong>{date}</strong>." id="H1szLa"
            values={{
              date: intlDate.format(willCancelAt),
              strong: (chunk: any) => Strongify(chunk),
            }}
          />
        </p>

        <p
          css={{
            margin: 0,
            color: palette.mediumGray,
            fontSize: 14,
            lineHeight: 1.33,
          }}
        >
          <FormattedMessage
            defaultMessage="Please note that newly added content or users that exceed your new plan’s allowances will be erased
          immediately prior to the above date." id="e9cgDB"
          />
        </p>
      </div>
    </div>
  );
}
